export default __webpack_public_path__ + "static/media/redmi1.39020eca.jpg";